module.exports = __webpack_public_path__ + "img/app-logo-white.756338cf.png";